import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-white flex flex-col">
      <Header />
      <main className="flex-1 pt-28 pb-20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 space-y-10">
          <header className="space-y-4 text-center">
            <h1 className="text-3xl md:text-4xl font-bold text-gray-900">Politique de confidentialité</h1>
            <p className="text-gray-600 text-lg">Dernière mise à jour : {new Date().toLocaleDateString('fr-FR')}</p>
          </header>

          <section className="space-y-6 text-gray-700 leading-relaxed">
            <p>
              Cette politique explique comment nous collectons, utilisons et protégeons vos données personnelles lorsque vous consultez notre site ou nous contactez.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900">1. Responsable du traitement</h2>
            <p>
              Le responsable du traitement est indiqué dans les mentions légales. Vous pouvez nous contacter à l'adresse suivante : <strong>contact@ctb28.fr</strong>.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900">2. Données collectées</h2>
            <ul className="list-disc ml-6 space-y-1">
              <li>Données de contact : nom, email, téléphone.</li>
              <li>Informations projet : type de projet, message descriptif.</li>
              <li>Logs techniques minimaux pour la sécurité (adresses IP éventuellement via l'infrastructure).</li>
            </ul>

            <h2 className="text-2xl font-semibold text-gray-900">3. Finalités</h2>
            <ul className="list-disc ml-6 space-y-1">
              <li>Répondre à vos demandes et préparer un premier échange / devis (mesures précontractuelles).</li>
              <li>Suivi commercial limité (intérêt légitime).</li>
              <li>Sécurisation et amélioration du site.</li>
            </ul>

            <h2 className="text-2xl font-semibold text-gray-900">4. Base légale</h2>
            <p>
              Les traitements reposent sur : (a) l'exécution de mesures précontractuelles lorsque vous nous contactez ; (b) notre intérêt légitime pour la gestion des relations et sécurité du site ; (c) votre consentement si vous cochez la case d'acceptation lors de l'envoi du formulaire.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900">5. Durée de conservation</h2>
            <p>
              Les données issues du formulaire de contact sont conservées jusqu'à 12 mois après le dernier échange puis supprimées ou anonymisées.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900">6. Destinataires</h2>
            <p>
              Les données sont exclusivement destinées au responsable ou à ses collaborateurs directs. Aucune revente ni cession à des tiers.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900">7. Sous-traitance & hébergement</h2>
            <p>
              L'infrastructure (hébergement, base de données) peut être assurée par un fournisseur tiers conforme au RGPD. Les données sont hébergées dans l'UE ou dans un pays disposant de garanties adéquates.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900">8. Vos droits</h2>
            <p>
              Vous disposez des droits d'accès, rectification, effacement, limitation, opposition et portabilité lorsque cela s'applique. Pour exercer vos droits : <strong>contact@ctb28.fr</strong>. Réponse sous 30 jours.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900">9. Sécurité</h2>
            <p>
              Mesures techniques : contrôle d'accès, mots de passe hashés, restrictions d'origine, bonne pratique de journalisation. Aucune méthode n'est infaillible mais nous appliquons des mesures proportionnées.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900">10. Cookies</h2>
            <p>
              Nous n'utilisons actuellement aucun cookie ou traceur à des fins publicitaires ou de mesure d'audience. Seuls des éléments techniques nécessaires au fonctionnement peuvent être utilisés. En cas d'ajout futur de traceurs soumis à consentement, un module dédié sera proposé.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900">11. Preuve et consentement</h2>
            <p>
              Lorsque vous soumettez le formulaire après avoir coché la case de consentement, nous enregistrons l'état du consentement et un horodatage attaché à la demande.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900">12. Réclamation</h2>
            <p>
              Vous pouvez introduire une réclamation auprès de la CNIL (www.cnil.fr) si vous estimez que vos droits ne sont pas respectés.
            </p>

            <p className="text-sm text-gray-500">Version informative. Elle pourra être ajustée selon l'évolution des traitements.</p>
          </section>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default PrivacyPolicy;
